import Louse from '@/assets/icons/louse.svg?component';

import type { SidebarItemConfig } from './types';

/** The cage level's lice entry and its pages. */
export const cageLiceItem: SidebarItemConfig = {
    id: 'cage-lice',
    label: 'sidebarItems.cageLevel.lice',
    analyticsLabel: 'Lice',
    path: '/lice',
    icon: Louse,
    exact: true,
    visibility: {
        requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'],
        requiresNonSmolt: true,
    },
    children: [
        {
            id: 'cage-lice-detections',
            label: 'sidebarItems.cageLevel.detections',
            analyticsLabel: 'Detections',
            path: '/lice/detections',
            exact: true,
            visibility: { requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'] },
        },
        {
            id: 'cage-lice-female',
            label: 'sidebarItems.cageLevel.matureFemaleLice',
            analyticsLabel: 'Mature female lice',
            path: '/lice/female',
            exact: true,
            visibility: {
                requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'],
                requiresLiceType: 'standard',
            },
        },
        {
            id: 'cage-lice-ovigerous',
            label: 'sidebarItems.cageLevel.ovigerousFemale',
            analyticsLabel: 'Ovigerous female',
            path: '/lice/ovigerousfemale',
            exact: true,
            visibility: {
                requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'],
                requiresLiceType: 'chilean',
            },
        },
        {
            id: 'cage-lice-mobile',
            label: 'sidebarItems.cageLevel.mobileLice',
            analyticsLabel: 'Mobile Lice',
            path: '/lice/mobile',
            exact: true,
            visibility: { requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'] },
        },
        {
            id: 'cage-lice-caligus',
            label: 'sidebarItems.cageLevel.caligusLice',
            analyticsLabel: 'Caligus',
            path: '/lice/caligus',
            exact: true,
            visibility: {
                requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'],
                requiresLiceType: 'standard',
            },
        },
        {
            id: 'cage-lice-graphs',
            label: 'sidebarItems.cageLevel.graphs',
            analyticsLabel: 'Graphs',
            path: '/lice/graphs',
            exact: true,
            visibility: { requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'] },
        },
        {
            id: 'cage-lice-report',
            label: 'sidebarItems.shared.liceReport',
            analyticsLabel: 'Lice report',
            path: '/lice/lice-report',
            exact: true,
            visibility: { requiresLicenses: ['LICE_COUNT.MIN', 'LICE_COUNT.MAX'] },
        },
    ],
};
